import { takeEvery } from 'redux-saga'
import { call, put, take, fork, select } from 'redux-saga/effects'
import callAny from './helpers/call_any'
import actionTypes from '../actions/actionTypes'
import { cartSync } from '../../sync'
import { cartSelectors } from 'redux/selectors'
import cartActions from 'redux/actions/cartActions'
import loginActions from 'redux/actions/loginActions'
import formatError from './helpers/error_formatter'
import upgradeSourceTypes from 'helpers/enums/metrics/upgradeSourceTypes'

function *getCartData() {

	let hasErrors

	while (true) {
		hasErrors = false
		yield take([actionTypes.CART_GET_DATA, actionTypes.STORE_PREVIEW_INITIALIZE])

		try {
			const response = yield call(cartSync.getCartData)
			if (response.error_code === 0) {
				yield put({
					type: actionTypes.CART_DATA_FETCHED,
					entities: response.payload.result.entities,
				})
			} else {
				hasErrors = true
				yield put({
					type: actionTypes.SYNC_UNCAUGHT_ERROR,
					payload: response.payload,
				})
			}
		} catch (error) {
			//console.log(error)
			hasErrors = true
			yield put({
				type: actionTypes.SYNC_UNCAUGHT_ERROR,
			})
		}

		if (!hasErrors) {
			yield take(actionTypes.CART_RESET)
		}
	}
}

function *toggleCart(action) {
	const libraryData = yield select(cartSelectors.cartDownloadProductSelector)
	const method = action.onCart ? cartSync.removeFromCart : cartSync.addToCart
	const response = yield call(method, action.entityUID, action.entityType, libraryData.libraryUID)
	if (response.error_code === 0) {
		if (action.onCart) {
			yield put({
				type: actionTypes.CART_ITEM_REMOVED,
				entities: response.payload.result.entities,
				entityUID: action.entityUID,
				entityType: action.entityType,
			})
		} else {
			yield put({
				type: actionTypes.CART_ITEM_ADDED,
				entities: response.payload.result.entities,
				entityUID: action.entityUID,
				entityType: action.entityType,
			})
		}
	} else {
		yield put(cartActions.cartItemFailed(action.entityUID))
	}
}

function *buyProduct() {
	while (true) {
		const action = yield take(actionTypes.CART_BUY_PRODUCT)
		try {
			const contextData = yield select(cartSelectors.cartDownloadProductSelector)
			if (!contextData.userIsLogged) {
				yield put(loginActions.userNotLoggedIn())
			} else {
				yield put(cartActions.cartDownloading(action.entityUID, action.entityType))
				const response = yield callAny(cartSync.downloadProduct, action.entityUID, action.entityType, action.libraryUID)
				yield put(cartActions.buyProductSuccess(
					action.entityUID,
					action.libraryUID,
					action.entityType,
					response.payload,
					response.message
				))
			}
		} catch (error) {
			const serverError = formatError(error)
			yield put(
				cartActions.cartItemFailed(
					action.entityUID,
					serverError,
					upgradeSourceTypes.STORE_DOWNLOAD,
				)
			)
		}
	}
}

export default [
	fork(getCartData),
	takeEvery(actionTypes.CART_TOGGLE, toggleCart),
	fork(buyProduct),
]
